import React from "react";
import "../styles/ponuda.scss";
import radnaUniforma from "../images/radna.webp";
import kuvarUniforma from "../images/kuvar.webp";
import medicinaUniforma from "../images/medicina.webp";

const NasaPonuda = () => {
  return (
    <section className="our-offer">
      <div className="container">
        <h2 className="title">NAŠA PONUDA</h2>
        <p className="description">
          Otkrivamo savršeni spoj funkcionalnosti, stila i kvaliteta u
          uniformama prilagođenim vašim potrebama.
        </p>
        <div className="offer-cards">
          <div className="card">
            <div className="icon">
              <img src={medicinaUniforma} alt="Medicinske uniforme" />
            </div>
            <h3>Medicinske uniforme</h3>
            <p>Udobnost i funkcionalnost za medicinske profesionalce.</p>
          </div>

          <div className="card">
            <div className="icon">
              <img src={kuvarUniforma} alt="Ugostiteljske uniforme" />
            </div>
            <h3>Kuvarske uniforme</h3>
            <p>Elegancija i profesionalizam za vaš tim.</p>
          </div>
          <div className="card">
            <div className="icon">
              <img src={radnaUniforma} alt="Radne uniforme" />
            </div>
            <h3>Radne uniforme</h3>
            <p>Praktične i izdržljive uniforme za sve sektore rada.</p>
          </div>
        </div>
        <a href="/uniforme" className="btn-primary">
          Pogledajte više
        </a>
      </div>
    </section>
  );
};

export default NasaPonuda;
